import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { IAuthCommon, IAuthTable } from '../auth.interfaces';
import { SearcherAuthActions, SearcherAuthActionTypes } from './searcher-auth.actions';

export const authAdapter: EntityAdapter<IAuthCommon> = createEntityAdapter<
  IAuthCommon
>();

export function authInitState(): IAuthTable {
  return authAdapter.getInitialState({});
}

export function SearcherAuthReducer(state = authInitState(), action: SearcherAuthActions) {
  switch (action.type) {
    case SearcherAuthActionTypes.SEARCHER_LOGIN_SUCCESS:
    case SearcherAuthActionTypes.SEARCHER_REFRESH_TOKEN_SUCCESS:

      return {
        ...state,
        ...action.payload,
      };

    case SearcherAuthActionTypes.SEARCHER_LOGOUT:
      return authInitState();

    default:
      return state;
  }
}
